<template>
    <div>
        <MainSwitch v-if="!modalData.onlyAddress" v-show="mainComponent === 'MainSwitch'" />
        <MainAddress v-show="mainComponent === 'MainAddress'" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import MainSwitch from "./MainSwitch";
import MainAddress from "./MainAddress";


export default {
    props: {
        emptyCart: Boolean,
        shopType: String,
        modalData: Object,
    },
    components: {
        MainSwitch,
        MainAddress,
    },
    created() {
        this.$store.commit("SET_MODAL_DATA", this.modalData);
        this.$store.commit("SET_SHOP_TYPE", this.shopType);
        this.$store.commit("SET_EMPTY_CART", this.emptyCart);

        if (this.modalData.onlyAddress) {
            this.$store.commit("SET_MAIN_COMPONENT", "MainAddress");
        } else {
            this.$store.commit("SET_MAIN_COMPONENT", "MainSwitch");
        }
    },
    computed: {
        ...mapState([
            "mainComponent",
        ]),
    },
};
</script>
